import React, { Component, PropTypes } from 'react';
import MapsMyPosition from 'material-ui/svg-icons/maps/my-location';
import DeviceLocationSearching from 'material-ui/svg-icons/device/location-searching';

class MyLocationButton extends Component {
  static propTypes = {
    searching: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
  };

  state = {
    searchingIcon: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.searching !== this.props.searching) {
      if (nextProps.searching) {
        this.setState({ searchingIcon: true });
        this.blinkInterval = setInterval(() => {
          this.setState({ searchingIcon: !this.state.searchingIcon });
        }, 1000);
      } else {
        clearInterval(this.blinkInterval);
        this.setState({ searchingIcon: false });
      }
    }
  }

  render() {
    const { searching, ...other } = this.props; // eslint-disable-line no-unused-vars
    return this.state.searchingIcon ?
      <DeviceLocationSearching {...other} /> :
      <MapsMyPosition {...other} />;
  }
}

export default MyLocationButton;



// WEBPACK FOOTER //
// ./src/components/Map/MyLocationButton.js